import React, { FC } from 'react';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { useStaticQuery, graphql } from 'gatsby';

interface EnquireBookingFormProps {
  userName?: string;
  userEmail?: string;
  setFormSuccess?: any;
  setBookingForm?: any;
}

const EnquireBookingFormQuery = () => {
  return useStaticQuery(graphql`
    query EnquireBookingFormQuery {
      strapiGlobal {
        footer {
          bookingForm {
            Title
            Description
            bookingURL
          }
        }
      }
    }
  `);
};

export const EnquireBookingForm: FC<EnquireBookingFormProps> = ({
  userName,
  userEmail,
  setFormSuccess,
  setBookingForm,
}) => {
  const data = EnquireBookingFormQuery();
  const { Title, Description, bookingURL } =
    data?.strapiGlobal?.footer?.bookingForm || {};
  useCalendlyEventListener({
    onEventScheduled: () => {
      setFormSuccess(true);
      setBookingForm(false);
    },
  });

  return (
    <div className="enquiremodal_booking_form">
      <div className="enquiremodal_booking_form-content">
        {Title && (
          <h4 className="enquiremodal_booking_form-content-title">{Title}</h4>
        )}
        {Description && (
          <p className="enquiremodal_booking_form-content-description">
            {Description}
          </p>
        )}
      </div>
      <InlineWidget
        url={bookingURL}
        prefill={{
          email: userEmail || '',
          name: userName || '',
        }}
      />
    </div>
  );
};
